import {Component, EventEmitter, HostListener, Injector, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {BaseDialog} from "../../BaseDialog";
import { ToastrService } from "ngx-toastr";
import { SyncService } from '../../../../services/sync.service';
import { AccessRights, UsersService, InterfacePermissions } from "../../../../services/users.service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-dialog-base',
    templateUrl: './dialog-base.component.html',
    styleUrls: ['./dialog-base.component.css'],
    standalone: false
})
export class DialogBaseComponent<T> extends BaseDialog implements OnInit {
  public AccessRights = AccessRights;
  public InterfacePermissions = InterfacePermissions;

  public model: T;// = new T();
  protected toastr: ToastrService;
  protected syncService: SyncService;
  public usersService: UsersService;
  protected translate: TranslateService;

  constructor(protected injector: Injector) {
    super();
    this.toastr = injector.get(ToastrService);
    this.syncService = injector.get(SyncService);
    this.usersService = injector.get(UsersService);
    this.translate = injector.get(TranslateService);
  }

  @Input() public Title: string;
  @Input() public ExitButton: boolean=false;
  @Input() public width: string = null;
  @Input() public height: string = null;
  @Input() public isSubmitDisabled: boolean = false;
  @Input() public isLoading: boolean = false;

  @Output() onCreated: EventEmitter<any> = new EventEmitter();

  public isOpen: boolean = false;

  @Input()
  public isHeaderHidden: boolean = false;

  public open(model: any, type: (new () => T) = undefined) {
    if (model)
      this.model = model;
    else
      if (type)
        this.model = new type();
    super.open(model);
  }

  public close() {
    this.isOpen = false;
    super.close();
  }

  public closeN(event) {
    this.close();
    event.stopPropagation();
  }

  public submit() {
    super.submit();
    this.isOpen = false;
  }

  public innerWidth: any;
  public innerHeight: any;

  ngOnInit() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }

  public canAccessComponent(rights: AccessRights): boolean {
    return this.usersService.IsPermitted(rights);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }

  public offsetX: number = 0;
  public offsetY: number = 0;
  public position: string = "relative";

  public isDragging: boolean = false;

  private relX: number = 0;
  private relY: number = 0;
  private Width: number = 700;
  private Height: number = 450;

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(moveEvent) {
    if (this.isDragging == false) {
      moveEvent.stopPropagation();
      moveEvent.preventDefault();
      return;
    }
    let diffX = moveEvent.pageX - this.relX;
    if (diffX >= 0 && diffX <= this.innerWidth - this.Width - 20)
      this.offsetX = diffX;
    let diffY = moveEvent.pageY - this.relY;
    if (diffY >= 0 && diffY <= this.innerHeight - this.Height - 20)
      this.offsetY = diffY;
    this.position = "absolute";
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(moveEvent) {
    this.isDragging = false;
  }

  @HostListener('document:keydown', ['$event'])
  onKeyPress(moveEvent) {
    if (moveEvent.keyCode == 27)
      this.close();
  }

  public onMouseDown(e: any) {
    if (this.isHeaderHidden) return;
    let parentElement = e.target.parentElement;
    if (!parentElement || parentElement.id == "closeBtn") {
      this.isDragging = false;
      e.stopPropagation();
      e.preventDefault();
      return;
    }
    this.Width = parentElement.clientWidth;
    this.Height = parentElement.clientHeight;
    this.relX = e.layerX;
    this.relY = e.layerY;
    this.isDragging = true;
    e.stopPropagation();
  }

}
